module.exports = __webpack_public_path__ + "static/media/logo-레인보우브레인.6961bf2e.png";